import * as React from "react";
import Placeholder from "@warda/library-ui/core/Placeholder";
import ViewerVideo from "@warda/library-ui/core/ViewerVideo";
import ImageZoom from "@warda/library-ui/core/ImageZoom";
import { MediaKind, useAppMediaTypeCtx, } from "@warda/library-ui/contexts/AppMediaTypeContext";
import getFileIcon from "@warda/library-ui/utils/getFileIcon";
import ViewerBox from "../../ViewerBox";
import { RENDITION } from "../../../interfaces";
import { getSharePageUrlFirmed, getSharePageViewerBoxData, } from "../../../api/fetchesApiSharePage";
import apiUrls from "../../../api/apiUrlsSharePage";
import { getPageCode, getSharePageAuthorization } from "../accessCodeUtil";
const Viewer = ({ file, handleError }) => {
    const appMediaTypeCtx = useAppMediaTypeCtx();
    const { fileId, mimeType } = file.data;
    const mediaKind = appMediaTypeCtx.mimeTypeToMediaKind(mimeType);
    const getSrcFirmedCB = React.useCallback((url) => {
        try {
            const signedUrl = getSharePageUrlFirmed(url);
            return signedUrl;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
    }, [handleError]);
    const getTileAdditionalParams = React.useCallback(() => {
        const accessCode = getPageCode();
        return { accessCode };
    }, []);
    if (mediaKind === MediaKind.VID) {
        const vidUrl = apiUrls.mediaDownload.url(fileId, RENDITION.video_HQ);
        return React.createElement(ViewerVideo, { src: vidUrl });
    }
    if (mediaKind === MediaKind.IMG) {
        const authorizationRequired = !!getSharePageAuthorization();
        return (React.createElement(ImageZoom, { src: apiUrls.mediaZoom.url({
                fileId,
                redirect: authorizationRequired,
            }), getSrcFirmed: authorizationRequired ? undefined : getSrcFirmedCB, getTileAdditionalParams: getTileAdditionalParams }));
    }
    if (mediaKind === MediaKind.DOC) {
        return React.createElement(ViewerBox, { fileId: fileId, getData: getSharePageViewerBoxData });
    }
    return (React.createElement("div", { style: {
            position: "relative",
            flex: 1,
            display: "flex",
            alignItems: "stretch",
            overflow: "hidden",
        } },
        React.createElement(Placeholder, { icon: getFileIcon(mimeType, appMediaTypeCtx.mimeTypeToMediaKind), iconStyle: { marginBottom: 10 }, label: "Zoom unavailable" })));
};
export default Viewer;
